import * as types from './constants';

export const initialState = {
  dataTable: [],
  loading: false,
  createLoading: false,
  mutatingId: null, // id currently being updated/deleted/reordered, for per-row loading state
  errors_api: {}
};

const actions = {
  // Errors live here rather than in the modal's own state, so without this they outlive the
  // modal that produced them and show up on the next rule opened.
  [types.CLEAR_COMMISSION_RULE_ERRORS]: state => ({
    ...state,
    errors_api: {}
  }),

  [types.GET_COMMISSION_RULES_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [types.GET_COMMISSION_RULES_DONE]: (state, { payload }) => ({
    ...state,
    loading: false,
    dataTable: payload
  }),
  [types.GET_COMMISSION_RULES_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload
  }),

  [types.CREATE_COMMISSION_RULE_REQUEST]: state => ({
    ...state,
    createLoading: true
  }),
  [types.CREATE_COMMISSION_RULE_DONE]: (state, { payload }) => ({
    ...state,
    createLoading: false,
    dataTable: [...state.dataTable, payload]
  }),
  [types.CREATE_COMMISSION_RULE_FAILED]: (state, { payload }) => ({
    ...state,
    createLoading: false,
    errors_api: payload
  }),

  [types.UPDATE_COMMISSION_RULE_REQUEST]: (state, { payload }) => ({
    ...state,
    mutatingId: payload.id
  }),
  [types.UPDATE_COMMISSION_RULE_DONE]: (state, { payload }) => ({
    ...state,
    mutatingId: null,
    dataTable: state.dataTable.map(rule => (rule.id === payload.id ? payload : rule))
  }),
  [types.UPDATE_COMMISSION_RULE_FAILED]: (state, { payload }) => ({
    ...state,
    mutatingId: null,
    errors_api: payload
  }),

  [types.DELETE_COMMISSION_RULE_REQUEST]: (state, { payload }) => ({
    ...state,
    mutatingId: payload.id
  }),
  [types.DELETE_COMMISSION_RULE_DONE]: (state, { payload }) => ({
    ...state,
    mutatingId: null,
    dataTable: state.dataTable.filter(rule => rule.id !== payload.id)
  }),
  [types.DELETE_COMMISSION_RULE_FAILED]: (state, { payload }) => ({
    ...state,
    mutatingId: null,
    errors_api: payload
  }),

  [types.REORDER_COMMISSION_RULE_REQUEST]: (state, { payload }) => ({
    ...state,
    mutatingId: payload.id
  }),
  [types.REORDER_COMMISSION_RULE_DONE]: (state, { payload }) => ({
    ...state,
    mutatingId: null,
    dataTable: payload
  }),
  [types.REORDER_COMMISSION_RULE_FAILED]: (state, { payload }) => ({
    ...state,
    mutatingId: null,
    errors_api: payload
  })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
